import React from "react"

const AgencyCodesContext = React.createContext({})

const { Provider, Consumer } = AgencyCodesContext

export { Provider, Consumer, AgencyCodesContext }
